<template>
  <div>
    <div v-if="konfigModel != null && konfigModel.merkmale && konfigModel.gruppen" style="height: 100%">
      <b-container fluid="true" style="height: 100%;">

        <b-row no-gutters style="height: 100%;">
          <b-col :lg="widthConfig" :sm="widthConfig" :md="widthConfig" :xl="widthConfig+1" style="padding-top: 90px">
            <Teileauswahl ref='teileauswahl'
                          :merkmale="konfigModel.merkmale"
                          :optionale-gruppen="konfigModel.optionaleGruppen"
                          :hinweistexte="konfigModel.texteExtern"
                          :part-sizes="partSizes"
                          :maxStklId="konfigModel.maxStuckelistenId"
                          :typen-schluessel="konfigModel.typenSchluessel"/>
            <Produktmerkmale ref='produktmerkmal'
                             :gruppen="konfigModel.gruppen"
                             :hinweistexte="konfigModel.texteExtern"
                             :zustand="konfigModel.zustand" />
            <ProductActions ref="productOverview"
                            :groesse="konfigModel.groesse"
                            :typen-schluessel="konfigModel.typenSchluessel"
                            :produkt-text="konfigModel.produktText"
                            :produkt-text-headline="konfigModel.produktTextHeadline"
                            :pps-nr="konfigModel.clientOverviewModel != null ? konfigModel.clientOverviewModel.ppsNummer : ''"
                            :lieferzustand-nr="konfigModel.clientOverviewModel != null ? konfigModel.clientOverviewModel.lieferzustandNr : ''"
                            :konfig-model="konfigModel"
                            :csrf-token="csrfToken"/>
          </b-col>
          <b-col :lg="width3D" :sm="width3D" :md="width3D" :xl="width3D-1" style="padding-top: 90px;height: auto">
            <Overview :konfig-model="konfigModel"/>
          </b-col>
        </b-row>

        <RequestQuotation :model="requestQuotationModel" ref="requestQuotationComponent" />
        <RequestInquiry :model="requestInquiryModel" ref="requestInquiryComponent" />
      </b-container>
    </div>
    <div v-if="konfigModel == null || !konfigModel.merkmale || !konfigModel.gruppen">
      <b-card style="padding-top: 70px; margin-left: 10px;">
        <b-card-text>
          {{$t('general.configurationLoading')}}
        </b-card-text>
      </b-card>
    </div>
  </div>
</template>

<script>
import RequestQuotation from "@/components/config-page/modal/RequestQuotation";
import RequestInquiry from "@/components/config-page/modal/RequestInquiry";
import ProductActions from "@/components/config-page/produkt/ProductActions";
import Overview from "@/components/config-page/overview/Overview";
import Produktmerkmale from "@/components/config-page/produktmerkmale/Produktmerkmale";
import Teileauswahl from "@/components/config-page/teileauswahl/Teileauswahl";
import axios from "axios";
import url from "../../../rest/url";
import isEmpty from "@/mixins/isempty";
import matomoTracking from "@/mixins/matomoTracking";

export default {
  name: "ConfigPage",
  mixins: [isEmpty, matomoTracking],
  components: {
    RequestQuotation,
    RequestInquiry,
    ProductActions,
    Overview,
    Produktmerkmale,
    Teileauswahl,
  },
  props: ['konfigModel', 'partSizes', 'requestQuotationModel', 'requestInquiryModel', 'widthConfig', 'width3D',
    'csrfToken'],
  mounted() {
    //Load UserData
    this.$store.dispatch('getUserDataWithOptionalAuthentication');
    console.log(this.$route.name)
    if (this.$route.name === 'ConfigPageByMaxStklId' && this.$route.params.maxStklId) {
      if (this.konfigModel === undefined || this.konfigModel.i18nBenennung === '') {
        this.$store.dispatch('initModelByMaxStklId', {maxStklId: this.$route.params.maxStklId, reset: false});
        this.setCustomUrl('/pdm_webapp/configuration/model/'+ this.$route.params.maxStklId)
      } else {
        //do nothing konfigmodel is already loaded
        this.setCustomUrl('/pdm_webapp/configuration/model/'+ this.konfigModel.maxStuckelistenId)
      }

    } else if (this.$route.name === 'ConfigPageBySizeType' && this.$route.params.maxStklId && this.$route.params.size && this.$route.params.type) {
      if (this.konfigModel === undefined || this.konfigModel.i18nBenennung === '') {
        this.$store.dispatch('initModelBySizeType', {
          type: this.$route.params.type,
          size: this.$route.params.size
        });
        this.setCustomUrl('/pdm_webapp/configuration/model/' + this.$route.params.maxStklId +'/type/'
            + this.$route.params.type + '/size/' + this.$route.params.size)
      } else {
        //do nothing konfigmodel is already loaded
        this.setCustomUrl('/pdm_webapp/configuration/model/' + this.konfigModel.maxStuckelistenId +'/type/'
            + this.konfigModel.typenSchluessel + '/size/' + this.konfigModel.groesse)
      }

    } else if (this.$route.name === 'ConfigPageByArticleNo' && this.$route.params.articleNumber && this.$route.params.deliveryCondition) {
      if (this.konfigModel === undefined || this.konfigModel.i18nBenennung === '') {
        this.$store.dispatch('initModelByArticleNo', {
          articleNumber: this.$route.params.articleNumber,
          deliveryCondition: this.$route.params.deliveryCondition,
          toConfigure: true
        });
        this.setCustomUrl('/pdm_webapp/configuration/article/' + this.$route.params.articleNumber
            +'/' + this.$route.params.deliveryCondition)
      } else {
        //do nothing konfigmodel is already loaded
        this.setCustomUrl('/pdm_webapp/configuration/article/' + this.$route.params.articleNumber
            +'/' + this.$route.params.deliveryCondition)
      }
    } else if (this.$route.name === 'ConfigPageStandard') {
      axios.get(url.apiLocation + '/configuration').then(response => {
        console.log(response)
      })
      this.setCustomUrl('/pdm_webapp/configuration')
    } else {
      this.$store.dispatch('initModelByMaxStklId', {maxStklId: '149691', reset:false});
      this.setCustomUrl('/pdm_webapp/configuration/model/149691')
    }
  },
}
</script>

<style scoped>

</style>